import React from "react";
import styles from "./ProgramBlog.module.css";
import Image from "next/image";
import Link from "next/link";

interface BlogData {
  id: number;
  title: string;
  category: string;
  date: string;
  reading_time: string;
  url: string;
  image: {
    url: string;
    name: string;
    width: number;
    height: number;
  }[];
}

interface ProgramBlogProps {
  Data?: BlogData[]; // Make it optional to prevent runtime errors
}

const ProgramBlog: React.FC<ProgramBlogProps> = ({ Data = [] }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Insights and Highlights</h2>
      <div className={styles.blogGrid}>
        {Data.map((blog) => (
          <div key={blog?.id} className={styles.blogCard}>
            <Link href={blog?.url} title={blog?.image[0]?.name || blog?.title}>
              <Image
                src={blog?.image[0]?.url}
                alt={blog?.image[0]?.name || blog?.title}
                title={blog?.image[0]?.name || blog?.title}
                className={styles.blogImage}
                width={blog?.image[0]?.width || 500}
                height={blog?.image[0]?.height || 300}
              />
              <div className={styles.blogContent}>
                <span className={styles.category}>{blog?.category}</span>
                <h3 className={styles.title}>{blog?.title}</h3>
                <div className={styles.meta}>
                  <span>{blog?.date}</span> • <span>{blog?.reading_time}</span>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgramBlog;
